import { useContext, useState, useEffect } from 'react';
import { AppContext } from '../Context';

//components
import MessageBox from '../components/MessageBox';
import InstructionBox from '../components/InstructionBox';
import AgreementBox from '../components/AgreementBox';
import OtpScreen from '../components/OtpScreen';
import WaitScreen from '../components/WaitScreen';
import NetworkVersionController from '../components/NetworkVersionController';
import PinNumberKeypad from '../components/PinNumberKeypad';

//controllers
import SvgFramesController from './SvgFramesController';

const GeneralComponentsController: React.FC = ({ }) => {
    //context
    const appContext = useContext(AppContext);
    //states
    const [svgFramesController, SetSvgFramesController] = useState(new SvgFramesController());
    //watchers
    useEffect(() => {
        const InitializeSvgFramesController = async () => {
            
            //load svg frames sample, load svg frames here
            // const _svgFramesController = svgFramesController;
            // await _svgFramesController.LoadAnimationFrames('successAnimation', 30, 30);
            // await _svgFramesController.LoadAnimationFrames('failAnimation', 30, 30);
            // await _svgFramesController.LoadAnimationFrames('repeatAnimation', 30, 30);
            //console.log('checksum: ' + JSON.stringify(_svgFramesController.svgFrameAnimatorSettings));
            // SetSvgFramesController({ ..._svgFramesController } as SvgFramesController);
        }

        InitializeSvgFramesController();
    }, []);

    return (
        <div className='GeneralComponentsController' style={{ position: 'absolute', width: '0', height: '0' }}>
            {/* <NavBar shouldHideNavBar={appContext.navBarShouldHide} /> */}
            <MessageBox message={appContext.popupMessage} SetMessage={appContext.SetPopupMessage} boxButtons={appContext.popupButtons} BoxActions={appContext.popupActions} />
            <InstructionBox
                instructions={appContext.popupInstructions} SetInstructions={appContext.SetPopupInstructions}
                previews={appContext.popupPreviews} SetPreviews={appContext.SetPopupPreviews}
                SetNavBarShouldHide={appContext.SetNavBarShouldHide}
                svgSettings={svgFramesController.svgFrameAnimatorSettings}
                shouldSvgAnimations={appContext.popupShouldSvgAnimations}
                popupInstructAction={appContext.popupInstructAction} SetPopupInstructAction={appContext.SetPopupInstructAction}
            />
            <AgreementBox
                message={appContext.agreementMessage} SetMessage={appContext.SetAgreementMessage}
                SetUsersAgreement={appContext.SetUsersAgreement}
            />
            <OtpScreen
                dburl={appContext.dburl} secret={appContext.secret}
                shouldVerificationCode={appContext.otpVerificationCode} SetShouldVerificationCode={appContext.SetOtpVerificationCode}
                subject={appContext.otpSubject} mode={appContext.otpMode}
                OnOtpResult={appContext.otpResultAction}
            />
            <PinNumberKeypad
                shouldVerificationKey={appContext.pinNumberVerificationKey} SetShouldVerificationKey={appContext.SetPinNumberVerificationKey}
                verificationMessage={appContext.pinNumberVerificationMessage} SetVerificationMessage={appContext.SetPinNumberVerificationMessage}
                SuccessAction={appContext.pinNumberSuccessAction} ResetPinAction={appContext.pinNumberResetPinAction}
            />
            <WaitScreen message={appContext.waitScreenMessage} shouldShowWaitScreen={appContext.waitScreenShouldShow} />
            <NetworkVersionController
                dburl={appContext.dburl} secret={appContext.secret} appLink={appContext.appLink} appBuild={appContext.appBuild}
                shouldCheckNetwork={true} shouldForceUpdateApp={true}
                SetPopupMessage={appContext.SetPopupMessage} SetPopupButtons={appContext.SetPopupButtons} SetPopupActions={appContext.SetPopupActions}
            />
        </div>
    );
}
export default GeneralComponentsController;